







import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  model: {
    prop: "visible",
    event: "input",
  },
})
export default class ShowHideItem extends Vue {
  @Prop({ type: String, required: true }) label!: string;
  @Prop() visible!: boolean | any[];
  @Prop() value!: any;

  private get iconClasses() {
    return [
      "fa-regular",
      "visibility-icon",
      `fa-${this.actualVisible ? "circle-dot" : "circle"}`,
    ];
  }

  private get actualVisible() {
    if (Array.isArray(this.visible)) {
      return this.visible.includes(this.value);
    } else {
      return Boolean(this.visible);
    }
  }

  private click() {
    if (Array.isArray(this.visible)) {
      const visibleCopy: any[] = [...this.visible];
      if (visibleCopy.includes(this.value)) {
        visibleCopy.splice(visibleCopy.indexOf(this.value), 1);
      } else {
        visibleCopy.push(this.value);
      }
      this.$emit("input", visibleCopy);
    } else {
      this.$emit("input", !this.visible);
    }
  }
}
